import GuestIndex from "@/views/guest/GuestIndex.vue";

const guest = [
    {
        path: '/guest',
        name: 'guest',
        component: GuestIndex,
        meta: {
            requiresAuth: true,
            roles: ['Super Admin', 'Admin Office'], 
        },
    }
]

export default guest;